// removed by extract-text-webpack-plugin
module.exports = {"tag-container":"src-templates----tags-module---tag-container---3o_ft","summary":"src-templates----tags-module---summary---1hL2M"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/tags.module.scss
// module id = 440
// module chunks = 183400410456155